"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promptLogin = exports.loginURL = void 0;
var _AUTHENDPOINT = 'https://id.comsel.net';
var _RESPONSETYPE = 'token';

function loginURL(clientID, redirectURI, scope, remember) {
  if (clientID === void 0) {
    clientID = "00000000-0000-0000-0000-000000000000";
  }

  if (redirectURI === void 0) {
    redirectURI = "";
  }

  if (scope === void 0) {
    scope = "readall writeall";
  }

  if (remember === void 0) {
    remember = false;
  }

  if (redirectURI.length === 0) {
    redirectURI = window.location.origin + window.location.pathname;
  }

  return _AUTHENDPOINT + "?response_type=" + _RESPONSETYPE + "&client_id=" + clientID + "&redirect_uri=" + encodeURIComponent(redirectURI) + "&scope=" + scope + (remember ? "&remember=true" : "");
}

exports.loginURL = loginURL;

function promptLogin(clientID, redirectURI, scope) {
  if (clientID === void 0) {
    clientID = "00000000-0000-0000-0000-000000000000";
  }

  if (redirectURI === void 0) {
    redirectURI = "";
  }

  if (scope === void 0) {
    scope = "readall writeall";
  }

  window.location.href = loginURL(clientID, redirectURI, scope);
}

exports.promptLogin = promptLogin;